import { render, staticRenderFns } from "./subfolder-list.vue?vue&type=template&id=897ffed0"
import script from "./subfolder-list.vue?vue&type=script&lang=js"
export * from "./subfolder-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports